<script>
import Main from './main.vue';

export default Main.extend({
  computed: {
    seriesData() {
      return this.graphicsData.map((line) => {
        const industryItem = this.$store.state.dictionaries.industry.find((el) => el.ID === line.Id);
        return {
          name: `${industryItem.Name}`,
          data: line.KpiData.sort((a, b) => a.CreationDateTime - b.CreationDateTime).map((point) => {
            return {
              x: point.CreationDateTime * 1000,
              y: point.Rating,
              errors: {
                serious: point.ErrorItemStatisticsData.Major,
                minor: point.ErrorItemStatisticsData.Minor,
                total: point.ErrorItemStatisticsData.Total,
              },
              qa: {
                level: point.QualityLevel,
                score: point.Rating,
              },
              risk: point.RisksData.Name,
              words: point.TotalWords,
            };
          }),
        };
      });
    },
  },
});
</script>
